export type LinePeriodFilter = "active" | "24h" | "7d" | "30d";

export const LINE_PERIOD_FILTER_DEFAULT: LinePeriodFilter = "active";

export const LINE_PERIOD_FILTER_LABELS: Record<LinePeriodFilter, string> = {
  active: "Produção ativa",
  "24h": "Últimos 24h",
  "7d": "Últimos 7 dias",
  "30d": "Últimos 30 dias",
};

export const LINE_PERIOD_QP_KEY = "period" as const;

export function parsePeriodFilter(qp: string | null): LinePeriodFilter {
  if (qp === "active" || qp === "24h" || qp === "7d" || qp === "30d") return qp;
  return LINE_PERIOD_FILTER_DEFAULT;
}
